export interface IProductMeasurement {
	'measurements.length'?: string;
	'measurements.shoulders'?: string;
	'measurements.chest'?: string;
	'measurements.waist'?: string;
	'measurements.hips'?: string;
	'measurements.sleeve'?: string;
	'measurements.crotch'?: string;
	'measurements.leg'?: string;
	'measurements.hem'?: string;
}

interface SFTransformationObject {
	sw?: number;
	sh?: number;
	sm?: string;
	strip?: string;
	fit?: string;
}

export interface IProductTransformationObject {
	xs?: SFTransformationObject;
	sm?: SFTransformationObject;
	md?: SFTransformationObject;
	lg?: SFTransformationObject;
	xl?: SFTransformationObject;
	xxl?: SFTransformationObject;
	xxxl?: SFTransformationObject;
	viewType?: string;
	strip?: string;
	pdp?: boolean;
	plp?: boolean;
}

export interface IProductImageOptions {
	viewType?: string;
	index?: number;
	transformationObject?: IProductTransformationObject;
	sizeSpecific?: boolean;
}

export interface IProductMeasurements {
	[key: string]: IProductMeasurement;
}

export interface IPriceRange {
	maxPrice: number;
	minPrice: number;
	pricebook: string;
}

export interface IProductPriceObject {
	value: number;
	currency: string;
	pricebook?: string;
}

export enum EVideoProviders {
	THRON_ASSET = 'Thron_Asset',
	THRON = 'Thron',
	VIMEO = 'Vimeo',
	CLOUDFLARE_STREAM = 'Cloudflare_Stream',
}

export interface IProductVideo {
	videoId?: string;
	position?: number;
	provider?: EVideoProviders;
}

export enum EPersonalizationStyle {
	allUppercase = 'allUppercase',
	titleCase = 'titleCase',
	preserveCase = 'preserveCase',
}

export type IPersonalizationStyle = keyof typeof EPersonalizationStyle;